import { render, staticRenderFns } from "./setPtenToEign.vue?vue&type=template&id=497feee4&scoped=true"
import script from "./setPtenToEign.vue?vue&type=script&lang=js"
export * from "./setPtenToEign.vue?vue&type=script&lang=js"
import style0 from "./setPtenToEign.vue?vue&type=style&index=0&id=497feee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497feee4",
  null
  
)

export default component.exports